const US_PREFIX = 'US-';

export const normalizeStateCode = (provinceCode: string | null | undefined): string | null => {
  if (!provinceCode) return null;
  const trimmed = provinceCode.trim().toUpperCase();
  if (!trimmed) return null;

  if (trimmed.startsWith(US_PREFIX)) return trimmed.slice(US_PREFIX.length);
  return trimmed;
};
